// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"591":"d25f96f1","787":"6788c29f"}[chunkId] + ".chunk.js";
};